export var DEV_REQUEST_ERR_KEY = 'devRequestError';
